'use strict';

/**
 * featureControl.js contains functions for controlling the features / their behaviour
 */

import {deviceOrientation, map} from '/main';

/**
 * Focus on a feature
 *
 * @param {*} extentCenter
 * @param {boolean|string} rotation
 * @param {?int} zoom
 * @param {?array} extent
 * @param {boolean} animate
 * @param {?bool|int} rotationValue
 */
export function focusOn(extentCenter, rotation, zoom, extent, animate, rotationValue = false) {
  let rotate = undefined;
  let zoomByExtent = undefined;
  let zoomByRotatedExtent = undefined;
  let rotatedExtent = undefined;

  if (extent !== null) {
    if (rotation === true && rotationValue === false) {
      rotatedExtent = [];
      rotatedExtent.push(extent[1]);
      rotatedExtent.push(extent[0]);
      rotatedExtent.push(extent[3]);
      rotatedExtent.push(extent[2]);

      zoomByRotatedExtent = map.getView().getZoomForResolution(map.getView().getResolutionForExtent(rotatedExtent, map.getSize()));
    } else if (rotation === true && rotationValue !== false) {
      rotate = rotationValue * (Math.PI / 180);
    } else {
      zoomByExtent = map.getView().getZoomForResolution(map.getView().getResolutionForExtent(extent, map.getSize()));
    }
  }

  if (animate === false) {
    map.getView().setCenter(extentCenter);
    if (rotation === true) {
      map.getView().setZoom(zoomByRotatedExtent !== undefined ? zoomByRotatedExtent : zoom);
    } else {
      map.getView().setZoom(zoomByExtent !== undefined ? zoomByExtent : zoom);
    }
    if (rotation === true) {
      switch (map.getView().get('rotationDirection')) {
        case 'clockwise':
          if (rotate === undefined) {
            rotate = Math.PI / 2;
          }
          break;
        case 'counterclockwise':
          if (rotate === undefined) {
            rotate = -Math.PI / 2;
          }
          break;
        default:
          if (rotate === undefined) {
            rotate = Math.PI / 2;
          }
      }

      map.getView().setRotation(rotate);
    }
  } else {
    switch (map.getView().get('rotationDirection')) {
      case 'clockwise':
        if (rotate === undefined) {
          rotate = Math.PI / 2;
        }
        break;
      case 'counterclockwise':
        if (rotate === undefined) {
          rotate = -Math.PI / 2;
        }
        break;
      default:
        if (rotate === undefined) {
          rotate = Math.PI / 2;
        }
    }

    if (deviceOrientation === 'landscape-primary') {
      if (rotation === 'base') {
        map.getView().animate({
          center: extentCenter,
          rotation: 0,
          zoom: zoomByExtent !== undefined ? zoomByExtent : zoom,
        });
      } else if (rotation === true) {
        map.getView().animate({
          center: extentCenter,
          rotation: rotate,
          zoom: zoomByRotatedExtent !== undefined ? zoomByRotatedExtent : zoom,
        });
      } else {
        map.getView().animate({
          center: extentCenter,
          rotation: 0,
          zoom: zoomByExtent !== undefined ? zoomByExtent : zoom,
        });
      }
    } else if (deviceOrientation === 'landscape-primary' || deviceOrientation === 'landscape-secondary') {
      if (rotation === 'base') {
        map.getView().animate({
          center: extentCenter,
          rotation: 0,
          zoom: zoomByExtent !== undefined ? zoomByExtent : zoom,
        });
      } else if (rotation === true) {
        map.getView().animate({
          center: extentCenter,
          rotation: rotate,
          zoom: zoomByRotatedExtent !== undefined ? zoomByRotatedExtent : zoom,
        });
      } else {
        map.getView().animate({
          center: extentCenter,
          zoom: zoomByExtent !== undefined ? zoomByExtent : zoom,
        });
      }
    } else {
      map.getView().animate({
        center: extentCenter,
        zoom: zoomByExtent !== undefined ? zoomByExtent : zoom,
      });
    }
  }
}
